function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import _size from "lodash/size";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import Menu from "semantic-ui-react/dist/es/collections/Menu/Menu.js";
import Accordion from "semantic-ui-react/dist/es/modules/Accordion/Accordion.js";
import { buildKeyFromStrings } from "../../../../../utils/build-key-from-strings";
import { Icon, ICON_NAMES } from "../../../../elements/Icon";
import { Modal } from "../../../../elements/Modal";
import { Divider } from "../../../../elements/Divider";
import { Logo } from "../../../../elements/Logo";
import { getLinkMarkup } from "../../utils/getLinkMarkup";
import { getScrollToHeight } from "./utils/getScrollToHeight";
import { getIsAccordionInView } from "./utils/getIsAccordionInView";
export var Component = function (_React$PureComponent) {
  _inherits(Component, _React$PureComponent);

  var _super = _createSuper(Component);

  function Component() {
    var _this;

    _classCallCheck(this, Component);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      activeAccordionItem: null
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function () {
      var activeAccordionItem = _this.state.activeAccordionItem;

      if (activeAccordionItem && !getIsAccordionInView(activeAccordionItem)) {
        var bottomOfActiveAccordionItem = activeAccordionItem.getBoundingClientRect().bottom;
        var currentScrollHeight = activeAccordionItem.offsetParent.scrollTop;
        activeAccordionItem.offsetParent.scrollTop = getScrollToHeight(currentScrollHeight, bottomOfActiveAccordionItem);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "createMenuRef", function (menu) {
      return _this.menu = menu;
    });

    _defineProperty(_assertThisInitialized(_this), "handleAccordionTitleClick", function (event) {
      if (_this.state.activeAccordionItem === event.currentTarget.offsetParent) {
        _this.forceUpdate();

        return;
      }

      _this.setState({
        activeAccordionItem: event.currentTarget.offsetParent
      });
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props = _this.props,
          activeNavigationItemIndex = _this$props.activeNavigationItemIndex,
          logoHref = _this$props.logoHref,
          logoSizes = _this$props.logoSizes,
          logoSrc = _this$props.logoSrc,
          logoSrcSet = _this$props.logoSrcSet,
          logoText = _this$props.logoText,
          navigationItems = _this$props.navigationItems;
      return React.createElement(Menu.Item, null, React.createElement(Modal, {
        header: React.createElement(Logo, {
          logoHref: logoHref,
          logoSizes: logoSizes,
          logoSrc: logoSrc,
          logoSrcSet: logoSrcSet,
          logoText: logoText
        }),
        isFullscreen: true,
        trigger: React.createElement(Icon, {
          name: ICON_NAMES.BARS
        })
      }, React.createElement("div", {
        ref: _this.createMenuRef
      }, React.createElement(Menu, {
        text: true,
        vertical: true
      }, navigationItems.map(function (_ref, index) {
        var subItems = _ref.subItems,
            text = _ref.text,
            navigationItemTarget = _ref.target,
            href = _ref.href;
        return _size(subItems) ? React.createElement(Accordion, {
          as: Menu.Item,
          key: buildKeyFromStrings(text, index),
          onTitleClick: _this.handleAccordionTitleClick,
          panels: [{
            title: {
              content: text,
              key: buildKeyFromStrings(text, index)
            },
            content: {
              content: subItems.map(function (_ref2, index) {
                var text = _ref2.text,
                    subItemTarget = _ref2.target,
                    href = _ref2.href;
                return getLinkMarkup(text, href, subItemTarget, index, activeNavigationItemIndex);
              }),
              key: buildKeyFromStrings(index, text)
            }
          }]
        }) : getLinkMarkup(text, href, navigationItemTarget, index, activeNavigationItemIndex);
      }), React.createElement(Divider, {
        size: "huge"
      })))));
    });

    return _this;
  }

  return Component;
}(React.PureComponent);
Component.defaultProps = {
  activeNavigationItemIndex: null,
  logoHref: '/',
  logoSizes: undefined,
  logoSrc: null,
  logoSrcSet: undefined,
  primaryCTA: null
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  activeNavigationItemIndex: PropTypes.number,
  logoHref: PropTypes.string,
  logoSizes: PropTypes.string,
  logoSrc: PropTypes.string,
  logoSrcSet: PropTypes.string,
  logoText: PropTypes.string.isRequired,
  navigationItems: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string,
    subItems: PropTypes.arrayOf(PropTypes.shape({
      href: PropTypes.string.isRequired,
      target: PropTypes.string,
      text: PropTypes.string.isRequired
    })),
    target: PropTypes.string,
    text: PropTypes.string.isRequired
  })).isRequired,
  primaryCTA: PropTypes.shape({
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired
  })
} : {};